// Colour palette for single-select options: ten hues x four shades.

export interface StatusColorDef {
  value: DataTableSingleSelectColor;
  hue: DataTableSingleSelectHue;
  shade: DataTableSingleSelectShade;
  label: string;
  chipClass: string;
  dotClass: string;
  /** solid fill for the round swatch in the options editor */
  swatchClass: string;
}

export const STATUS_HUES: { value: DataTableSingleSelectHue; label: string }[] = [
  { value: "grey", label: "Grey" },
  { value: "blue", label: "Blue" },
  { value: "sky", label: "Sky" },
  { value: "teal", label: "Teal" },
  { value: "green", label: "Green" },
  { value: "amber", label: "Amber" },
  { value: "orange", label: "Orange" },
  { value: "red", label: "Red" },
  { value: "pink", label: "Pink" },
  { value: "violet", label: "Violet" },
];

export const STATUS_SHADES: { value: DataTableSingleSelectShade; label: string }[] = [
  { value: "light", label: "Light" },
  { value: "soft", label: "Soft" },
  { value: "bold", label: "Bold" },
  { value: "dark", label: "Dark" },
];

/** ordered shade-major: the first ten are the light row, then soft, bold, dark */
export const STATUS_COLORS: StatusColorDef[] = [
  { value: "grey", hue: "grey", shade: "light", label: "Grey ┬╖ light", chipClass:
    "border-slate-200 bg-slate-100 text-slate-700 dark:border-slate-700/60 dark:bg-slate-800/60 dark:text-slate-300",
    dotClass: "bg-slate-500", swatchClass: "bg-slate-300" },
  { value: "blue", hue: "blue", shade: "light", label: "Blue ┬╖ light", chipClass:
    "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900/40 dark:bg-blue-950/30 dark:text-blue-400",
    dotClass: "bg-blue-500", swatchClass: "bg-blue-200" },
  { value: "sky", hue: "sky", shade: "light", label: "Sky ┬╖ light", chipClass:
    "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900/40 dark:bg-sky-950/30 dark:text-sky-400",
    dotClass: "bg-sky-500", swatchClass: "bg-sky-200" },
  { value: "teal", hue: "teal", shade: "light", label: "Teal ┬╖ light", chipClass:
    "border-teal-200 bg-teal-50 text-teal-700 dark:border-teal-900/40 dark:bg-teal-950/30 dark:text-teal-400",
    dotClass: "bg-teal-500", swatchClass: "bg-teal-200" },
  { value: "green", hue: "green", shade: "light", label: "Green ┬╖ light", chipClass:
    "border-green-200 bg-green-50 text-green-700 dark:border-green-900/40 dark:bg-green-950/30 dark:text-green-400",
    dotClass: "bg-green-500", swatchClass: "bg-green-200" },
  { value: "amber", hue: "amber", shade: "light", label: "Amber ┬╖ light", chipClass:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-400",
    dotClass: "bg-amber-500", swatchClass: "bg-amber-200" },
  { value: "orange", hue: "orange", shade: "light", label: "Orange ┬╖ light", chipClass:
    "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-900/40 dark:bg-orange-950/30 dark:text-orange-400",
    dotClass: "bg-orange-500", swatchClass: "bg-orange-200" },
  { value: "red", hue: "red", shade: "light", label: "Red ┬╖ light", chipClass:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-900/40 dark:bg-red-950/30 dark:text-red-400",
    dotClass: "bg-red-500", swatchClass: "bg-red-200" },
  { value: "pink", hue: "pink", shade: "light", label: "Pink ┬╖ light", chipClass:
    "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900/40 dark:bg-rose-950/30 dark:text-rose-400",
    dotClass: "bg-rose-500", swatchClass: "bg-rose-200" },
  { value: "violet", hue: "violet", shade: "light", label: "Violet ┬╖ light", chipClass:
    "border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-900/40 dark:bg-violet-950/30 dark:text-violet-400",
    dotClass: "bg-violet-500", swatchClass: "bg-violet-200" },
  { value: "grey-soft", hue: "grey", shade: "soft", label: "Grey ┬╖ soft", chipClass:
    "border-slate-300 bg-slate-200 text-slate-900 dark:border-slate-700/60 dark:bg-slate-800/60 dark:text-slate-100",
    dotClass: "bg-slate-600", swatchClass: "bg-slate-400" },
  { value: "blue-soft", hue: "blue", shade: "soft", label: "Blue ┬╖ soft", chipClass:
    "border-blue-300 bg-blue-200 text-blue-900 dark:border-blue-700/60 dark:bg-blue-800/60 dark:text-blue-100",
    dotClass: "bg-blue-600", swatchClass: "bg-blue-400" },
  { value: "sky-soft", hue: "sky", shade: "soft", label: "Sky ┬╖ soft", chipClass:
    "border-sky-300 bg-sky-200 text-sky-900 dark:border-sky-700/60 dark:bg-sky-800/60 dark:text-sky-100",
    dotClass: "bg-sky-600", swatchClass: "bg-sky-400" },
  { value: "teal-soft", hue: "teal", shade: "soft", label: "Teal ┬╖ soft", chipClass:
    "border-teal-300 bg-teal-200 text-teal-900 dark:border-teal-700/60 dark:bg-teal-800/60 dark:text-teal-100",
    dotClass: "bg-teal-600", swatchClass: "bg-teal-400" },
  { value: "green-soft", hue: "green", shade: "soft", label: "Green ┬╖ soft", chipClass:
    "border-green-300 bg-green-200 text-green-900 dark:border-green-700/60 dark:bg-green-800/60 dark:text-green-100",
    dotClass: "bg-green-600", swatchClass: "bg-green-400" },
  { value: "amber-soft", hue: "amber", shade: "soft", label: "Amber ┬╖ soft", chipClass:
    "border-amber-300 bg-amber-200 text-amber-900 dark:border-amber-700/60 dark:bg-amber-800/60 dark:text-amber-100",
    dotClass: "bg-amber-600", swatchClass: "bg-amber-400" },
  { value: "orange-soft", hue: "orange", shade: "soft", label: "Orange ┬╖ soft", chipClass:
    "border-orange-300 bg-orange-200 text-orange-900 dark:border-orange-700/60 dark:bg-orange-800/60 dark:text-orange-100",
    dotClass: "bg-orange-600", swatchClass: "bg-orange-400" },
  { value: "red-soft", hue: "red", shade: "soft", label: "Red ┬╖ soft", chipClass:
    "border-red-300 bg-red-200 text-red-900 dark:border-red-700/60 dark:bg-red-800/60 dark:text-red-100",
    dotClass: "bg-red-600", swatchClass: "bg-red-400" },
  { value: "pink-soft", hue: "pink", shade: "soft", label: "Pink ┬╖ soft", chipClass:
    "border-rose-300 bg-rose-200 text-rose-900 dark:border-rose-700/60 dark:bg-rose-800/60 dark:text-rose-100",
    dotClass: "bg-rose-600", swatchClass: "bg-rose-400" },
  { value: "violet-soft", hue: "violet", shade: "soft", label: "Violet ┬╖ soft", chipClass:
    "border-violet-300 bg-violet-200 text-violet-900 dark:border-violet-700/60 dark:bg-violet-800/60 dark:text-violet-100",
    dotClass: "bg-violet-600", swatchClass: "bg-violet-400" },
  { value: "grey-bold", hue: "grey", shade: "bold", label: "Grey ┬╖ bold", chipClass:
    "border-slate-500 bg-slate-500 text-white dark:text-white dark:border-slate-500 dark:bg-slate-500",
    dotClass: "bg-white/80", swatchClass: "bg-slate-500" },
  { value: "blue-bold", hue: "blue", shade: "bold", label: "Blue ┬╖ bold", chipClass:
    "border-blue-500 bg-blue-500 text-white dark:text-white dark:border-blue-500 dark:bg-blue-500",
    dotClass: "bg-white/80", swatchClass: "bg-blue-500" },
  { value: "sky-bold", hue: "sky", shade: "bold", label: "Sky ┬╖ bold", chipClass:
    "border-sky-500 bg-sky-500 text-white dark:text-white dark:border-sky-500 dark:bg-sky-500",
    dotClass: "bg-white/80", swatchClass: "bg-sky-500" },
  { value: "teal-bold", hue: "teal", shade: "bold", label: "Teal ┬╖ bold", chipClass:
    "border-teal-500 bg-teal-500 text-white dark:text-white dark:border-teal-500 dark:bg-teal-500",
    dotClass: "bg-white/80", swatchClass: "bg-teal-500" },
  { value: "green-bold", hue: "green", shade: "bold", label: "Green ┬╖ bold", chipClass:
    "border-green-500 bg-green-500 text-white dark:text-white dark:border-green-500 dark:bg-green-500",
    dotClass: "bg-white/80", swatchClass: "bg-green-500" },
  { value: "amber-bold", hue: "amber", shade: "bold", label: "Amber ┬╖ bold", chipClass:
    "border-amber-500 bg-amber-500 text-amber-950 dark:text-amber-950 dark:border-amber-500 dark:bg-amber-500",
    dotClass: "bg-amber-900/60", swatchClass: "bg-amber-500" },
  { value: "orange-bold", hue: "orange", shade: "bold", label: "Orange ┬╖ bold", chipClass:
    "border-orange-500 bg-orange-500 text-white dark:text-white dark:border-orange-500 dark:bg-orange-500",
    dotClass: "bg-white/80", swatchClass: "bg-orange-500" },
  { value: "red-bold", hue: "red", shade: "bold", label: "Red ┬╖ bold", chipClass:
    "border-red-500 bg-red-500 text-white dark:text-white dark:border-red-500 dark:bg-red-500",
    dotClass: "bg-white/80", swatchClass: "bg-red-500" },
  { value: "pink-bold", hue: "pink", shade: "bold", label: "Pink ┬╖ bold", chipClass:
    "border-rose-500 bg-rose-500 text-white dark:text-white dark:border-rose-500 dark:bg-rose-500",
    dotClass: "bg-white/80", swatchClass: "bg-rose-500" },
  { value: "violet-bold", hue: "violet", shade: "bold", label: "Violet ┬╖ bold", chipClass:
    "border-violet-500 bg-violet-500 text-white dark:text-white dark:border-violet-500 dark:bg-violet-500",
    dotClass: "bg-white/80", swatchClass: "bg-violet-500" },
  { value: "grey-dark", hue: "grey", shade: "dark", label: "Grey ┬╖ dark", chipClass:
    "border-slate-700 bg-slate-700 text-white dark:border-slate-600 dark:bg-slate-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-slate-700" },
  { value: "blue-dark", hue: "blue", shade: "dark", label: "Blue ┬╖ dark", chipClass:
    "border-blue-700 bg-blue-700 text-white dark:border-blue-600 dark:bg-blue-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-blue-700" },
  { value: "sky-dark", hue: "sky", shade: "dark", label: "Sky ┬╖ dark", chipClass:
    "border-sky-700 bg-sky-700 text-white dark:border-sky-600 dark:bg-sky-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-sky-700" },
  { value: "teal-dark", hue: "teal", shade: "dark", label: "Teal ┬╖ dark", chipClass:
    "border-teal-700 bg-teal-700 text-white dark:border-teal-600 dark:bg-teal-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-teal-700" },
  { value: "green-dark", hue: "green", shade: "dark", label: "Green ┬╖ dark", chipClass:
    "border-green-700 bg-green-700 text-white dark:border-green-600 dark:bg-green-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-green-700" },
  { value: "amber-dark", hue: "amber", shade: "dark", label: "Amber ┬╖ dark", chipClass:
    "border-amber-700 bg-amber-700 text-white dark:border-amber-600 dark:bg-amber-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-amber-700" },
  { value: "orange-dark", hue: "orange", shade: "dark", label: "Orange ┬╖ dark", chipClass:
    "border-orange-700 bg-orange-700 text-white dark:border-orange-600 dark:bg-orange-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-orange-700" },
  { value: "red-dark", hue: "red", shade: "dark", label: "Red ┬╖ dark", chipClass:
    "border-red-700 bg-red-700 text-white dark:border-red-600 dark:bg-red-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-red-700" },
  { value: "pink-dark", hue: "pink", shade: "dark", label: "Pink ┬╖ dark", chipClass:
    "border-rose-700 bg-rose-700 text-white dark:border-rose-600 dark:bg-rose-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-rose-700" },
  { value: "violet-dark", hue: "violet", shade: "dark", label: "Violet ┬╖ dark", chipClass:
    "border-violet-700 bg-violet-700 text-white dark:border-violet-600 dark:bg-violet-700 dark:text-white",
    dotClass: "bg-white/80", swatchClass: "bg-violet-700" },
];

export function statusColorToken(
  hue: DataTableSingleSelectHue,
  shade: DataTableSingleSelectShade
): DataTableSingleSelectColor {
  return shade === "light" ? hue : `${hue}-${shade}`;
}

export function getStatusColor(
  color: DataTableSingleSelectColor | string | undefined
): StatusColorDef {
  return STATUS_COLORS.find((item) => item.value === color) ?? STATUS_COLORS[1];
}

/** Pick the next unused light-row colour for a new option. */
export function nextSingleSelectColor(
  usedColors: DataTableSingleSelectColor[]
): DataTableSingleSelectColor {
  const used = new Set(usedColors);
  const candidates = STATUS_COLORS.filter(
    (item) => item.shade === "light" && item.hue !== "grey"
  );
  const unused = candidates.find((item) => !used.has(item.value));
  return (unused ?? candidates[usedColors.length % candidates.length]).value;
}

let draftIdCounter = 0;

export function createSingleSelectOptionDraft(
  label = "",
  color?: DataTableSingleSelectColor
): DataTableSingleSelectOptionDraft {
  draftIdCounter += 1;
  return {
    id: `select-option-${draftIdCounter}`,
    label,
    color: color ?? "blue",
  };
}

/** Hex values for each palette token — unique per shade so API round-trip preserves bold/light/soft/dark */
export const STATUS_COLOR_HEX: Record<DataTableSingleSelectColor, string> = {
  grey: "#64748b",
  blue: "#3b82f6",
  sky: "#0ea5e9",
  teal: "#14b8a6",
  green: "#22c55e",
  amber: "#f59e0b",
  orange: "#f97316",
  red: "#ef4444",
  pink: "#f43f5e",
  violet: "#8b5cf6",
  "grey-soft": "#94a3b8",
  "blue-soft": "#60a5fa",
  "sky-soft": "#38bdf8",
  "teal-soft": "#2dd4bf",
  "green-soft": "#4ade80",
  "amber-soft": "#fbbf24",
  "orange-soft": "#fb923c",
  "red-soft": "#f87171",
  "pink-soft": "#fb7185",
  "violet-soft": "#a78bfa",
  "grey-bold": "#475569",
  "blue-bold": "#2563eb",
  "sky-bold": "#0284c7",
  "teal-bold": "#0d9488",
  "green-bold": "#16a34a",
  "amber-bold": "#d97706",
  "orange-bold": "#ea580c",
  "red-bold": "#dc2626",
  "pink-bold": "#e11d48",
  "violet-bold": "#7c3aed",
  "grey-dark": "#334155",
  "blue-dark": "#1d4ed8",
  "sky-dark": "#0369a1",
  "teal-dark": "#0f766e",
  "green-dark": "#15803d",
  "amber-dark": "#b45309",
  "orange-dark": "#c2410c",
  "red-dark": "#b91c1c",
  "pink-dark": "#be123c",
  "violet-dark": "#6d28d9",
};

function parseHexColor(hex: string): [number, number, number] | null {
  const normalized = hex.trim().replace(/^#/, "");
  if (!/^[0-9a-f]{3}([0-9a-f]{3})?$/i.test(normalized)) {
    return null;
  }

  const expanded =
    normalized.length === 3
      ? normalized
          .split("")
          .map((char) => char + char)
          .join("")
      : normalized;

  return [
    Number.parseInt(expanded.slice(0, 2), 16),
    Number.parseInt(expanded.slice(2, 4), 16),
    Number.parseInt(expanded.slice(4, 6), 16),
  ];
}

function hexColorDistance(a: string, b: string): number {
  const rgbA = parseHexColor(a);
  const rgbB = parseHexColor(b);
  if (!rgbA || !rgbB) return Number.POSITIVE_INFINITY;

  return (
    (rgbA[0] - rgbB[0]) ** 2 +
    (rgbA[1] - rgbB[1]) ** 2 +
    (rgbA[2] - rgbB[2]) ** 2
  );
}

export function singleSelectColorToHex(
  color: DataTableSingleSelectColor | string | undefined
): string {
  if (!color) return STATUS_COLOR_HEX.blue;
  if (color.startsWith("#")) return color;
  return STATUS_COLOR_HEX[color as DataTableSingleSelectColor] ?? STATUS_COLOR_HEX.blue;
}

export function resolveSingleSelectColorFromHex(
  hex: string | undefined
): DataTableSingleSelectColor {
  if (!hex?.trim()) return "blue";

  const normalized = singleSelectColorToHex(hex).toLowerCase();
  const exact = STATUS_COLORS.find(
    (item) => STATUS_COLOR_HEX[item.value].toLowerCase() === normalized
  );
  if (exact) return exact.value;

  let best: DataTableSingleSelectColor = "blue";
  let bestDistance = Number.POSITIVE_INFINITY;

  for (const item of STATUS_COLORS) {
    const distance = hexColorDistance(normalized, STATUS_COLOR_HEX[item.value]);
    if (distance < bestDistance) {
      bestDistance = distance;
      best = item.value;
    }
  }

  return best;
}
